<template>
    <div style="width:100%">
        <ul class="orgstruck-list">
            <!-- 上级公司 -->
            <li v-for="parentCom in parentComs" class="orgstruck-item">
                <div class="com-first" @click="switchComBlock(parentCom.id)">
                    <i class="icon iconfont icon-com font-gray3"></i>
                    <span>{{parentCom.name}}</span><span class="fr mr30">{{parentCom.level}} 级公司</span>
                    <i class="icon iconfont arrow" :class="{'icon-down' : !parentCom.expanded, 'icon-up' : parentCom.expanded}"></i>
                </div>
                <div class="depart-post" :class="{'display-none' : !parentCom.expanded, 'display-block' :parentCom.expanded }">
                    <div class="post-third">
                        <div class="post-item">
                            <div v-for="comPost in parentCom.comRoleList" class="name" :class="{active : isSelected(comPost.id)}" @click="asSelected(comPost)">
                                <i class="icon iconfont icon-post font-gray3"></i>
                                <span>{{comPost.name}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <!-- 本公司 -->
            <li class="orgstruck-item">
                <div class="com-first" @click="switchComBlock(ctxCom.id)">
                    <i class="icon iconfont icon-com font-gray3"></i>
                    <span>{{ctxCom.name}} （本公司）</span>
                    <i class="icon iconfont arrow" :class="{'icon-down' : !ctxCom.expanded, 'icon-up' : ctxCom.expanded}"></i>
                </div>
                <div class="depart-post" :class="{'display-none' : !ctxCom.expanded, 'display-block' :ctxCom.expanded }">
                    <div class="post-third">
                        <div class="post-item">
                            <div v-for="comPost in ctxCom.comRoleList" class="name" :class="{active : isSelected(comPost.id)}" @click="asSelected(comPost)">
                                <i class="icon iconfont icon-post font-gray3"></i>
                                <span>{{comPost.name}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </li>

        </ul>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import merchtAllApi from '../../api/merchtAll'
    import { getUserScopeEntity } from '../index'

    //=> depart { id, name , roles[{..., comName, comLevel}] }
    function toDepartList(comRoleList, com) {
        comRoleList = comRoleList || [];
        let retRoleList = [];
        let tmpList = comRoleList.split('departId', -1);
        //console.log(tmpList);
        //
        let retList = [];
        tmpList.forEach(function (roleList) {
            let depart = {
                roles: []
            };
            retList.push(depart);
            roleList.forEach(function (roleInfo) {
                depart.id = roleInfo.departId;
                depart.name = roleInfo.departName;
                roleInfo.comName = com.name;
                roleInfo.comLevel = com.level;
                depart.roles.push(roleInfo);
            });
        });
        //
        return retList;
    }

    export default {
        name: 'swb-com-action-post-select',
        desc: '选择具有操作权限的岗位',
        //
        props: {
            rescUrl: {
                //目标资源url
                type: String
            },
            action: {
                //目标操作（代码）
                type: String
            },
            initPostId: {
                //初始目标操作岗位id
                type: Number,
                default: null
            },
            useParents: {
                //是否使用上级公司
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                ctxCom: {},
                //
                parentComs: [],
                //选中的信息
                postId: null,
                postName: null,
                departId: null,
                departName: null,
                comId: null,
                comName: null,
                comLevel: null
            };
        },
        //
        created(){
            let userScope = getUserScopeEntity();
            //获取当前公司的信息
            this.ctxCom = {
                id: userScope.comId,
                bizUnitId: userScope.bizUnitId,
                name: userScope.comName,
                level: userScope.comLevel,
                //=> depart { id, name , roles[{..., comName, comLevel}] }
                departList: [],
                //数据是否已获取标记
                dataFetched: false,
                //是否展开
                expanded: true
            };
            //根据需要获取上级公司列表
            if(this.useParents && this.ctxCom.level > 1) {
                this.fetchParentComList(userScope.comId, userScope.bizUnitId);
            }
            //
            this.fetchComPostList();
        },

        methods: {
            findComById(comId){
                let targetCom = null;
                //
                if(comId == this.ctxCom.id) {
                    //本公司
                    targetCom = this.ctxCom;
                }
                else {
                    //上级公司
                    targetCom = this.parentComs.find(function (com) {
                        return com.id == comId;
                    });
                }
                //
                return targetCom;
            },
            //恢复初始岗位id的选择状态
            initCtxPostIdSelection(){
                let initPostId = this.initPostId;
                if(initPostId != null) {
                    let comRoleList = this.ctxCom.comRoleList;
                    let initPost = comRoleList.find(function (item) {
                        return item.id == initPostId;
                    });
                    if(initPost != null) {
                        this.asSelected(initPost);
                    }
                }
            },
            //获取公司岗位列表
            fetchComPostList(comId, bizUnitId){
                comId = comId || this.ctxCom.id;
                bizUnitId = bizUnitId || this.ctxCom.bizUnitId;
                //
                let postData = {};
                postData.comId = comId;
                postData.bizUnitId = bizUnitId;
                postData.rescUrl = this.rescUrl;
                postData.action = this.action;

                let self = this;
                //
                merchtAllApi.getComRoleListByContext(postData, function (result) {
                    if(result.type == 'info') {
                        let comRoleList = result.data || [];
                        //
                        let targetCom = self.findComById(comId);
                        //
                        targetCom.dataFetched = true;
                        self.$set(targetCom, 'comRoleList', comRoleList)
                        //
                        if(comId == self.ctxCom.id) {
                            self.initCtxPostIdSelection();
                        }
                    }
                    else {
                        MsgBox.warning('获取岗位信息失败' + (result.message || ''));
                    }
                });

            },
            //获取上级公司列表
            fetchParentComList(){
                let self = this;
                //
                merchtAllApi.getParentComListByContext({
                    comId: self.ctxCom.bizUnitId
                }, function (result) {
                    if(result.type == 'info') {
                        let parentComs = result.data || [];
                        //初始化
                        parentComs.forEach(function (com) {
                            //
                            com.dataFetched = false;
                            //
                            com.expanded = false;
                        });
                        //
                        self.parentComs = parentComs;
                        //
                        //console.log('------- 上级公司 ------');
                        //console.log(self.parentComs);
                    }
                    else {
                        MsgBox.warning('获取上级公司信息失败' + (result.message || ''));
                    }
                });
            },
            //切换公司块
            switchComBlock(comId){
                let targetCom = this.findComById(comId);
                //
                targetCom.expanded = !targetCom.expanded;
                //
                if(targetCom.expanded && !targetCom.dataFetched) {
                    this.fetchComPostList(targetCom.id, targetCom.bizUnitId);
                }
            },
            //判断是否选中状态
            isSelected(postId){
                return this.postId == postId;
            },
            //设置为选中状态
            asSelected(post){
                this.postId = post.id;
                this.postName = post.name;
                this.departId = post.departId;
                this.departName = post.departName;
                this.comId = post.comId;
                this.comName = post.comName;
                this.comLevel = post.comLevel;
                this.bizUnitId = post.bizUnitId;
            },
            //结果数据
            getResultData(){
                return {
                    postId: this.postId,
                    postName: this.postName,
                    departId: this.departId,
                    departName: this.departName,
                    comId: this.comId,
                    comName: this.comName,
                    comLevel: this.comLevel,
                    bizUnitId: this.bizUnitId
                };
            }
        }

    }

</script>



// WEBPACK FOOTER //
// src/compo/merchant/ComActionPostSelect.vue